import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import EmericRouter from './Routes'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <EmericRouter />
  </React.StrictMode>
)
